import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  // Check if on process access permission routes
  const isProcessAccessPermissionRoute = pathname?.includes('/process/process-access/process-access-permission')
  // Check if on new profile routes
  const isNewProfileRoute = pathname?.includes('/design/lib-profile/new-profile')
  // Check if on new process routes
  const isNewProcessRoute = pathname?.includes('/design/process/new-process')
  // Check if on library access setting route
  const isLibraryAccessSettingRoute = pathname?.includes('/design/lib-profile/library-access-setting')
  // Highlight Design menu when on process access setting
  const shouldHighlightDesign = isProcessAccessPermissionRoute && to === '/design'
  // Highlight Process Access Setting menu item when on that route
  const shouldHighlightProcessAccessSetting = isProcessAccessPermissionRoute && to === '/process/process-access/process-access-permission'
  // Highlight Library Design menu item when on new profile routes
  const shouldHighlightLibraryDesign = isNewProfileRoute && to === '/design/lib-profile/record-profile-design'
  // Highlight Process Design menu item when on new process routes
  const shouldHighlightProcessDesign = isNewProcessRoute && to === '/design/process/process-list'
  
  const isActive = shouldHighlightDesign || shouldHighlightProcessAccessSetting || shouldHighlightLibraryDesign || shouldHighlightProcessDesign || (!isProcessAccessPermissionRoute && !isNewProfileRoute && !isNewProcessRoute && checkIsActive(pathname, to) && !(isLibraryAccessSettingRoute && to === '/library'))
  const {config} = useLayout()
  const {app} = config

  return (
    <div className='menu-item'>
      <Link 
        className={clsx('menu-link without-sub', {active: isActive})} 
        to={to}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title === 'Access' ? 'Access Permission' : title }</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
